<template>
  <div>
    <el-dialog ref="dialog" custom-class="w-900 h-480 ovf-auto" :title="title">
      <div class="pos-rel h-60">
        <el-button type="primary" class="add-rule-btn" @click="openAddRule">添加规则</el-button>

        <el-select v-model="value" placeholder="请选择父级" class="select-btn">
          <el-option
            v-for="item in ruleLevel"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>

        <el-input placeholder="请输入内容" v-model="keyword" class="search-btn w-300" @keyup.enter.native="searchMsg()">
          <el-button slot="append" icon="search" @click="searchMsg()"></el-button>
        </el-input>
      </div>
      <div>
        <el-table
        :data="showData"
        stripe
        style="width: 100%">
          <el-table-column
          prop="title"
          label="规则名称">
          </el-table-column>
          <el-table-column
          prop="name"
          label="规则标识"
          width="180">
          </el-table-column>
          <el-table-column
          inline-template
          label="操作"
          width="100">
            <div>
              <el-button size="small" @click="selectRule(row)">选择</el-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <add-rule ref="addRule" :ruleTitle="ruleTitle" v-on:getNewRules="getNewRules"></add-rule>
  </div>
</template>
<style scoped>
.search-btn {
  position: absolute;
  top: 0px;
  right: 0px;
}
.select-btn{
  position: absolute;
  top: 0;
  right:310px;
}
.add-rule-btn{
  position: absolute;
  left:10px;
  top: 0;
}
</style>
<script>
  import http from '../../../assets/js/http'
  import addRule from './addRule'
  export default {
    props: {
      title: {
        type: String,
        default() {
          return '权限规则绑定'
        }
      }
    },
    data() {
      return {
        keyword: '',
        tableData: [],
        showData: [],
        value: '',
        ruleTitle: '添加规则',
        ruleLevel: [
          {
            title: '无',
            id: -1
          }
        ]
      }
    },
    methods: {
      open() {
        this.$refs.dialog.open()
      },
      closeDialog() {
        this.$refs.dialog.close()
      },
      openAddRule() {
        this.$refs.dialog.close()
        setTimeout(() => {
          this.$refs.addRule.open()
        },500)
      },
      // 子组件添加完规则，传递给父组件，重新获取数据，避免刷新界面
      getNewRules(newRules) {
        this.ruleLevel = [{
          title: '无',
          id: -1
        }]
        this.apiGet('admin/rules').then((res) => {
          if (res.code == 200) {
            this.tableDataShow = _(res.data).forEach((res) => {
              res.showInput = false
            })
            this.tableData = this.tableDataShow
            this.showData = this.tableData
            let array = []
            _(res.data).forEach((r) => {
              if (r.level == 1) {
                array.push(r)
              }
            })
            _(array).forEach((r) => {
              this.ruleLevel.push({
                title: r.title,
                id: r.id
              })
            })
          } else {
            _g.dealError(this, res)
          }
        })
      },
      searchMsg() {
        if (this.keyword) {
          this.showData = _.remove(_.cloneDeep(this.tableData), (item) => {
            return item.title.indexOf(this.keyword) > -1 || item.name.indexOf(this.keyword) > -1
          })
        } else {
          this.showData = this.tableData
        }
      },
      selectRule(item) {
        setTimeout(() => {
          this.$emit('selectRule', item.id, item.else, item.title)
        }, 0)
        this.closeDialog()
      },
      getRules() {
        if (!this.tableData.length) {
          this.apiGet('admin/rules').then((res) => {
            if (res.code == 200) {
              this.tableDataShow = _(res.data).forEach((res) => {
                res.showInput = false
              })
              this.tableData = this.tableDataShow
              this.showData = this.tableData
              let array = []
              _(res.data).forEach((r) => {
                if (r.level == 1) {
                  array.push(r)
                }
              })
              _(array).forEach((r) => {
                this.ruleLevel.push({
                  title: r.title,
                  id: r.id
                })
              })
            } else {
              _g.dealError(this, res)
            }
          })
        }
      },
      unique(arr) {
        let res = []
        let json = {}
        _(arr).forEach((r) => {
          if (!json[r]) {
            res.push(r)
            json[r] = 1
          }
        })
        return res
      }
    },
    created() {
      let data = store.state.rules
      if (data && data.length) {
        this.tableDataShow = _(data).forEach((res) => {
          res.showInput = false
        })
        this.tableData = this.tableDataShow
        this.showData = this.tableData
      } else {
        this.getRules()
      }
    },
    components: {
      addRule
    },
    watch: {
      value() {
        if (this.value) {
          if (this.value != -1) {
            var array = []
            let ids = []
            _(this.tableData).forEach((data) => {
              if (data.pid == this.value) {
                array.push(data)
                _(this.tableData).forEach((d) => {
                  if (data.id == d.pid) {
                    array.push(d)
                  }
                })
              }
            })
            this.showData = array
          } else {
            this.showData = this.tableData
          }
        }
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// rule.vue?d0077c4a